import React, {Component} from 'react';

export default class Loader extends Component {
  render() {
    return (
      <div className={'content-loader ' + this.props.loaderHiding}></div>
    );
  }
}